export default __webpack_public_path__ + "static/media/17t.de26690d.jpg";